import { Button, Form } from "antd";
import { UserSelection } from "Components/Form/UserSelection";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { I18N_NS } from "Config/i18n";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { projectsDataStore } from "Stores";
import { notificationSuccess } from "utils/libHelpers/AntdNotification";

interface ChangeFilesOwnerFormProps extends ModalComponentProps {
  fileIds: number[];
  onSubmitSuccess?: () => void;
}

export const ChangeFilesOwnerForm: FC<ChangeFilesOwnerFormProps> = ({ hideModal, fileIds, onSubmitSuccess }) => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  const [loading, setLoading] = useState<boolean>(false);

  const handleFinish = async (values: { newOwnerId: number }) => {
    try {
      setLoading(true);
      const formData: API_ChangeFileOwnerRequest = {
        fileIds: fileIds,
        ownerId: values.newOwnerId,
      };
      await API.newData(API_URL.FILES.changeFileOwner(projectsDataStore.projectId), formData);
      notificationSuccess(t("Success"), t("The owner of the selected files was changed successfully."));
      if (onSubmitSuccess) {
        onSubmitSuccess();
      }
      hideModal();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onFinish={handleFinish} layout="vertical">
      <Form.Item name="newOwnerId" rules={[{ required: true, message: t("This field is required") }]}>
        <UserSelection placeholder={t("New Owner")} hideInactiveUsers />
      </Form.Item>
      <div className="text-right">
        <Button type="primary" htmlType="submit" loading={loading}>
          {t("Confirm")}
        </Button>
      </div>
    </Form>
  );
};
